import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';

import { NSCustomizedReportingGridConstants } from '@ruby/configs/customized-reporting-grid.constants';
import { ICRFavoriteReport } from '@ruby/modules/customized-reporting/models/report.interface';
import { IUnitTrainFilters, IUTFiltersConfigurations } from '@ruby/modules/unit-train/models/unit-train.interface';
import { EGridType } from '@ruby/shared/enums/grid.enums';
import { IShipment, IShipmentAttributes, IShipmentTrace } from '@ruby/shared/models/shipments/shipments.interface';
import { GridCustomizedReportingService } from '@ruby/shared/services/grid-customized-reporting.service';

@Component({
  selector: 'ng-ut-results-map',
  templateUrl: './ut-results-map.component.html',
  styleUrls: ['./ut-results-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UTResultsMapComponent {
  @Input() filtersConfigs?: Partial<IUTFiltersConfigurations>;
  @Input() loading!: boolean;
  @Input() shipments!: Array<IShipment>;
  @Input() traces?: IShipmentTrace;
  @Output() makeAdvanceSearch = new EventEmitter<IUnitTrainFilters>();
  @Output() viewPermit = new EventEmitter<IShipmentAttributes>();
  @Output() viewTrainConsist = new EventEmitter<IShipmentAttributes>();
  @Output() viewRoute = new EventEmitter<IShipmentAttributes>();
  @Output() clearRoute = new EventEmitter();
  @ViewChild('expansionPanelFilters') filtersPanel!: MatExpansionPanel;
  reportType = EGridType.UT_MAPPING;
  private filters?: IUnitTrainFilters;

  constructor(private customizedReportingService: GridCustomizedReportingService) {}

  /**
   * Save Filters
   *
   * @summary set filters and makes a call to search with filters
   * @param $filters: IUnitTrainFilters
   * @return void
   */
  saveFilters($filters: IUnitTrainFilters): void {
    this.filtersPanel.expanded = false;
    this.filters = $filters;
    this.emitMakeAdvanceSearch();
  }

  /**
   * Emit Make Advance Search
   *
   * @summary emit an event to make a search
   * @return void
   */
  emitMakeAdvanceSearch(): void {
    this.makeAdvanceSearch.emit(this.filters);
  }

  /**
   * Create Customized Report
   *
   * @summary call create customized report
   * @param $filters: { filters: Partial<IUnitTrainFilters>; formValue: string }
   * @returns void
   */
  createReport($filters: { filters: Partial<IUnitTrainFilters>; formValue: string; selectedReport?: ICRFavoriteReport }): void {
    this.customizedReportingService.createCustomizedReport(
      'Mapping',
      this.reportType,
      NSCustomizedReportingGridConstants.getGridData(this.reportType),
      [],
      NSCustomizedReportingGridConstants.getGridOptions(this.reportType, $filters.formValue, JSON.stringify($filters.filters)),
      $filters.selectedReport
    );
  }
}
